module.exports = __webpack_public_path__ + "assets/img/77bf67c29227512b244bdf31c57ddc5e.png";